export const SET_CURRENT_PRODUCT = 'addToCart/SET_CURRENT_PRODUCT';
export const SET_IS_SIZES_VISIBLE = 'addToCart/SET_IS_SIZES_VISIBLE';
export const SET_SIZE_GUIDE = 'addToCart/SET_SIZE_GUIDE';
export const SET_SIZE_PROMPT_TYPE = 'addToCart/SET_SIZE_PROMPT_TYPE';
